
































import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";
import {
  IRouterGenericConfiguration,
  ICommandDestinationGenericConfiguration
} from "sitewhere-configuration-model";

import NewCommandRouterChooser from "./NewCommandRouterChooser.vue";
import DeviceTypeMappingRouterSummary from "./routers/devicetypemapping/Summary.vue";
import DeviceTypeMappingRouterCreateDialog from "./routers/devicetypemapping/SettingsCreateDialog.vue";

import {
  ContentSection,
  ContentLink,
  ContentWarning
} from "sitewhere-ide-components";
import { VCard } from "vuetify/lib";

@Component({
  components: {
    VCard,
    ContentSection,
    ContentLink,
    ContentWarning,
    NewCommandRouterChooser,
    DeviceTypeMappingRouterSummary,
    DeviceTypeMappingRouterCreateDialog
  }
})
export default class CommandRouterSection extends Vue {
  @Prop() readonly router!: IRouterGenericConfiguration;
  @Prop() readonly destinations!: ICommandDestinationGenericConfiguration[];
  @Ref() readonly chooser!: NewCommandRouterChooser;
  @Ref() readonly dtmRouterCreate!: DeviceTypeMappingRouterCreateDialog;

  /** Check for device type mapping router */
  get isDeviceTypeMappingRouter(): boolean {
    return this.router && this.router.type == "device-type-mapping";
  }

  /** Send event to unset the router */
  onUnsetCommandRouter(): void {
    this.$emit("unset");
  }

  /** Open chooser for adding command router */
  onAddCommandRouter(): void {
    this.chooser.openChooser();
  }

  /** Show dialog for creating command router */
  onCommandRouterChosen(type: string): void {
    if (type == "device-type-mapping") {
      this.dtmRouterCreate.openDialog();
    }
  }

  /** Indicate that updates were made to command router */
  onCommandRouterUpdate(): void {
    this.$emit("update");
  }
}
